import React, { BaseSyntheticEvent, useEffect, useState } from "react";
import MarkdownView from "./markdown/MarkdownView";
import { useLocation } from "react-router";

export type VersionViewProps = {
  versions: string[];
  versionText: { version: string; versionText: string };
  getVersion: (version: string) => void;
  downloadVersion: (version: string) => void;
};

let loadingTimeoutID: NodeJS.Timeout | null = null;

const VersionView = ({
  versions,
  versionText,
  getVersion,
  downloadVersion,
}: VersionViewProps): JSX.Element => {
  const [active, setActive] = useState<number | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [versionTextList, setVersionTextList] = useState<Array<string>>(
    new Array(versions.length).fill("")
  );

  //   useEffect(() => {
  //     if (versionTextList[0] !== "") {
  //       const newList = new Array(versions.length).fill("");
  //       newList[0] = versionText;
  //       setVersionTextList(newList[0]);
  //     }
  //   }, [location.pathname]);

  useEffect(() => {
    if (versions.length > 0) {
      setActive(0);
      setVersionTextList((prev) => {
        const newList = [...prev];
        newList[0] = versionText.versionText;
        return newList;
      });
      setTextHeight();
    }
  }, [versions]);

  useEffect(() => {
    setVersionTextList((prev) => {
      const newList = [...prev];
      const index = versions.indexOf(versionText.version);
      newList[index] = versionText.versionText;
      return newList;
    });
    setTimeout(() => {
      setTextHeight();
      if (loadingTimeoutID) clearTimeout(loadingTimeoutID);
      setLoading(false);
    }, 100);
  }, [versionText.version]);

  const handleButtonClick = (index: number) => {
    if (active === index) {
      setActive(null);
    } else {
      setActive(index);

      if (versionTextList[index] === "") {
        getVersion(versions[index]);

        loadingTimeoutID = setTimeout(() => {
          setLoading(true);
        }, 500);
      }
    }
    setTextHeight();
  };

  const setTextHeight = () => {
    setTimeout(() => {
      const selectedText = document.querySelector(
        ".show .version-text"
      ) as HTMLElement;
      const notSelectedText = document.querySelectorAll(
        ".version-text"
      ) as NodeListOf<HTMLElement>;

      if (notSelectedText) {
        notSelectedText.forEach((text) => {
          text.style.height = "0px";
        });
      }

      if (selectedText) {
        const height = selectedText.scrollHeight;
        selectedText.style.height = `${height}px`;
      }
    }, 100);
  };

  const handleDownloadClick = (e: BaseSyntheticEvent, version: string) => {
    e.stopPropagation();
    if (downloadVersion) downloadVersion(version);
  };

  return (
    <div>
      {versions.map((version, index) => {
        if (index === versions.length - 1) {
          return (
            <div
              className={`version-container ${index === active ? "show" : ""}`}
              key={version}
            >
              <button type="button" onClick={() => handleButtonClick(index)}>
                <h3 className="last-item">{version}</h3>
                <div
                  className="version download"
                  onClick={(e) => handleDownloadClick(e, version)}
                >
                  <span className="icon icon-download-dark align-right"></span>
                </div>
                <span className="icon icon-up-dark align-right"></span>
                {loading && <span className="spinner"></span>}
              </button>
              <div className="version-text">
                <MarkdownView displayedMarkdown={versionTextList[index]} />
              </div>
            </div>
          );
        }
        return (
          <div
            className={`version-container ${index === active ? "show" : ""}`}
            key={version}
          >
            <button type="button" onClick={() => handleButtonClick(index)}>
              <h3>{version}</h3>
              <div
                className="version download"
                onClick={(e) => handleDownloadClick(e, version)}
              >
                <span className="icon icon-download-dark align-right"></span>
              </div>
              <span className="icon icon-up-dark align-right"></span>
              {loading && <span className="spinner"></span>}
            </button>
            <div className="version-text">
              <MarkdownView displayedMarkdown={versionTextList[index]} />
            </div>
          </div>
        );
      })}
    </div>
  );
};
export default VersionView;
